import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Button,
  Paper,
  IconButton,
  TextField,
  MenuItem,
  Tabs,
  Tab,
} from "@mui/material";

import {
  projectActivitiesTable,
  projectEmployeesTable,
  projectTaskTable,
} from "../../config/grid-columns-defs";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  deleteProject,
  getLowestLevelTask,
  getProjectById,
  getProjectTasks,
  // updateProject,
} from "../../api/project";
import { handleAxiosError } from "../../config/action-config";
import {
  createTask,
  deleteTask,
  updateTask,
  updateTaskBudget,
} from "../../api/task";
import {
  assignEmployeeToProject,
  deleteEmployeeProject,
  updateEmployeeProject,
} from "../../api/employeeProject";

import { showAlert } from "../../actions/alert";

import {
  allActivityAttachment,
  createActivity,
  deleteActivity,
  getActivities,
  getRecurringActivities,
  updateActivity,
} from "../../api/activity";
import { Forum, InsertDriveFile } from "@mui/icons-material";
import ConditionalRenderer from "../../component/ConditionalRenderer";
import AgGridPaginatedTable from "../../component/AgGridPaginatedTable";
import UpdateActivityDialog from "../projects/dialog.update-activity";
import AddActivityDialog from "../projects/dialog.add-activity";
import DeleteDialog from "../projects/dialog.delete";
import ChatDrawer from "../projects/chat-drawer";
import { getProjects } from "../../api/project";
import ItemDialogUploadDoc from "../../component/DialogUploadExcel";
import ProjectRecurringActivities from "../projectRecurringActivities/project.Recurring.Activitites";
import TabPanel from "../../component/TabPanel";
import ProjectActivitiesAddActivityDialog from "../projects/dialog.project.activities.add-activity";
import ProjectActivitiesUpdateActivityDialog from "../projects/dialog.project.activities.update-activity";

const deleteApis = {
  PROJECT: deleteProject,
  TASK: deleteTask,
  EMPLOYEE: deleteEmployeeProject,
  ACTIVITY: deleteActivity,
};

const emptyProjectData = {
  project_name: "",
  project_type: "",
  project_description: "",
  budget: "",
  id: "",
  pm_id: "",
  start_date: "",
  end_date: "",
  status: "",
  creation_date: "",
  customer_id: "",
  customer_name: "",
  customer_email: "",
};

export default function ProjectActivities() {
  // useEffect(() => {
  //   const projectType = localStorage.getItem("projectType");

  // }, []);
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(user.role === "User" ? 1 : 0);
  const [loading, setLoading] = useState(true);
  const [projectData, setProjectData] = useState(emptyProjectData);
  const [lowestTasks, setLowestTasks] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [activities, setActivities] = useState([]);
  const [employeeTaskName, setEmployeeTaskName] = useState("");
  const [employeeTabEmployeeName, setEmployeeTabEmployeeName] = useState("");
  const [activityTaskName, setActivityTaskName] = useState("");
  const [activityEmployeeName, setActivityEmployeeName] = useState("");
  const [activitiesRefreshCount, setActivitiesRefreshCount] = useState(0);
  function refreshactivitiesTable() {
    setActivitiesRefreshCount((prev) => prev + 1);
  }
  const [projectList, setProjectList] = useState([]);
  const [taskCodeBool, setTaskCodeBool] = useState(false);
  const [projectId, setProjectId] = useState("");
  const [projectName, setProjectName] = useState("");
  const [openDialog, setOpenDialog] = useState({
    DELETE: false,
    ADD_ACTIVITY: false,
    UPDATE_ACTIVITY: false,
    UPLOAD_EXCEL: false,
  });

  const [openChatDrawer, setOpenChatDrawer] = useState(false);
  const [selectedActivityRow, setSelectedActivityRow] = useState(0);

  if (!projectActivitiesTable.some((d) => d.headerName === "Comments")) {
    projectActivitiesTable.unshift(
      {
        headerName: "Comments",
        wrapText: true,
        autoHeight: true,
        cellStyle: () => ({
          fontSize: "11px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }),
        headerClass: "justify-center",
        cellClass: "pmt-ag-cell-font justify-center",
        minWidth: 100,
        cellRenderer: (params) => (
          <IconButton
            color="primary"
            // onClick={() => {
            //   setSelectedActivityRow(params.data.id);
            //   setOpenChatDrawer(true);
            // }}
          >
            <Forum />
          </IconButton>
        ),
      },
      {
        headerName: "Documents",
        wrapText: true,
        autoHeight: true,
        cellStyle: { fontSize: "11px" },
        minWidth: 100,
        headerClass: "justify-center",
        cellClass: "pmt-ag-cell-font justify-center",
        cellRenderer: (params) => (
          <IconButton
            title="Documents"
            color="primary"
            onClick={() => {
              navigate(`activities-documents/${params.data.id}`);
            }}
          >
            <InsertDriveFile />
          </IconButton>
        ),
      }
    );
  }

  function toggleDialogOpen(dialog) {
    setOpenDialog((prev) => ({ ...prev, [dialog]: !openDialog[dialog] }));
    console.log("dialo==", dialog);
  }

  useEffect(() => {
    getProjectsData();
  }, []);
  async function getProjectsData() {
    try {
      const { data } = await getProjects({}, user.token);

      setProjectList(data.data);
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  async function loadLowestLevelTask() {
    let specific = false;
    if (user.role === "User") {
      specific = true;
    }
    try {
      const { data } = await getLowestLevelTask(
        projectName,
        user.token,
        specific
      );
      setLowestTasks(data.data);
    } catch (error) {
      handleAxiosError(error);
    }
  }
  async function loadMasterData() {
    try {
      const { data } = await getProjectById(
        projectName,
        {
          task_name: employeeTaskName,
          employee_name: employeeTabEmployeeName,
        },
        user.token
      );
      setProjectData(data.data.project);
      setEmployees(data.data.employees);
      return {
        rows: data.data.employees,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (projectName) {
      loadLowestLevelTask();
      loadMasterData();
      loadProjectActivities(10, 0);
    }
    return;
  }, [projectName]);
  async function loadProjectActivities(limit, offset) {
    try {
      const { data } = await getActivities(
        projectName,
        {
          is_recurring: false,
          task_name: activityTaskName,
          employee_name: activityEmployeeName,
          limit,
          offset,
        },
        user.token
      );
      setActivities(data.data);
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });

  async function onDelete() {
    const deleteApi = deleteApis[deletingContent.table];
    try {
      const { data } = await deleteApi(deletingContent.row, user.token);
      dispatch(showAlert(data.msg));
      setDeletingContent({ type: "", row: 0 });
      setSelectedActivityRow(0);
      switch (deletingContent.table) {
        case "ACTIVITY":
          refreshactivitiesTable();
          break;
        default:
          break;
      }
    } catch (error) {
      setDeletingContent({ table: "", row: 0 });
      handleAxiosError(error);
    }
  }

  async function onActivityAdd(postData) {
    const combinedData = { ...postData, is_recurring: false };
    try {
      const { data } = await createActivity(
        { ...combinedData, project_id: projectData.id },
        user.token
      );
      refreshactivitiesTable();
      toggleDialogOpen("ADD_ACTIVITY");
      dispatch(showAlert(data.msg));
    } catch (error) {
      toggleDialogOpen("ADD_ACTIVITY");
      handleAxiosError(error);
    }
  }

  async function onActivityUpdate(patchData) {
    try {
      const { data } = await updateActivity(
        selectedActivityRow,
        patchData,
        user.token
      );
      refreshactivitiesTable();
      toggleDialogOpen("UPDATE_ACTIVITY");
      dispatch(showAlert(data.msg));
      setSelectedActivityRow(0);
    } catch (error) {
      toggleDialogOpen("UPDATE_ACTIVITY");
      handleAxiosError(error);
    }
  }
  const onItemDialogAttachmentSubmit = async (formData) => {
    try {
      const { data } = await allActivityAttachment(formData, user.token);

      // getTicketAttachmentTableData();
      dispatch(showAlert(data.msg));
      toggleDialogOpen("UPLOAD_EXCEL");
    } catch (error) {
      toggleDialogOpen("UPLOAD_EXCEL");
      handleAxiosError(error, dispatch);
    }
  };
  useEffect(() => {
    refreshactivitiesTable();
  }, [projectName, activityTaskName, activityEmployeeName]);

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 ,borderRadius:"10px"}}>
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3} style={{width: "20%"}}>
          <TextField
            label="Projects"
            value={projectName}
            variant="outlined"
            select
            fullWidth
            onChange={(e) => {
              setProjectName(e.target.value);
            }}
      
          >
            <MenuItem value="">Select</MenuItem>
            {projectList?.map((c, i) => (
              <MenuItem key={i} value={c.id}>
                {c.project_name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Paper>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          marginTop:"10px",
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Activities"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
          />
          <Tab
            label="Recurring Activities"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        {projectName && (
          <Paper>
            <Box
              sx={{
                display: { lg: "flex", md: "flex", sm: "block", xs: "grid" },
                alignItems: "center",
                justifyContent: "space-between",
                p: 2,
                borderBottom: 1,
              }}
            >
              <ConditionalRenderer
                conditions={[
                  user.role === "Admin",
                  user.role === "User",
                  user.role === "Trial_User",
                  projectData.pm_id === user.roleId,
                ]}
                match="SOME"
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    toggleDialogOpen("ADD_ACTIVITY");
                  }}
                  className="blue-button"
                  sx={{
                    marginBottom: { xs: "5px", md: "0px" },
                    marginRight: { sm: "5px", md: "10px" },
                  }}
                >
                  Add Activity
                </Button>

                <ConditionalRenderer
                  conditions={[Boolean(selectedActivityRow)]}
                >
                  <Button
                    variant="contained"
                    className="blue-button"
                    onClick={() => {
                      toggleDialogOpen("UPDATE_ACTIVITY");
                    }}
                    sx={{
                      marginBottom: { xs: "5px", md: "0px" },
                      marginRight: { sm: "5px", md: "10px" },
                    }}
                  >
                    Update Selected
                  </Button>
                </ConditionalRenderer>
              </ConditionalRenderer>
              <ConditionalRenderer
                conditions={[
                  user.role === "Admin",
                  projectData.pm_id === user.roleId,
                ]}
                match="SOME"
              >
                <ConditionalRenderer
                  conditions={[Boolean(selectedActivityRow)]}
                >
                  <Button
                    className="blue-button"
                    variant="contained"
                    sx={{
                      marginBottom: { xs: "5px", md: "0px" },
                      marginRight: { sm: "5px", md: "10px" },
                    }}
                    onClick={() => {
                      setDeletingContent({
                        table: "ACTIVITY",
                        row: selectedActivityRow,
                      });
                    }}
                  >
                    Delete Selected
                  </Button>
                </ConditionalRenderer>
              </ConditionalRenderer>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                display={{ sm: "flex !important" }}
                sx={{
                  float: { lg: "right" },
                }}
              >
                <TextField
                  size="small"
                  fullWidth
                  sx={{
                    marginRight: { sm: "5px", md: "10px" },
                    marginBottom: { xs: "5px", md: "0px" },
                  }}
                  value={activityEmployeeName}
                  label="Employee Name"
                  onChange={(e) => {
                    setActivityEmployeeName(e.target.value);
                  }}
                  // rowsMax={1}
                />
                <TextField
                  fullWidth
                  size="small"
                  value={activityTaskName}
                  sx={{
                    marginRight: { sm: "5px", md: "10px" },
                    marginBottom: { xs: "5px", md: "0px" },
                  }}
                  label="Task Name"
                  onChange={(e) => {
                    setActivityTaskName(e.target.value);
                  }}
                />

                <Button
                  fullWidth
                  variant="contained"
                  style={{ padding: "5px 7px" }}
                  sx={{
                    marginBottom: { xs: "5px", md: "0px" },
                  }}
                  onClick={() => {
                    toggleDialogOpen("UPLOAD_EXCEL");
                  }}
                  className="blue-button"
                >
                  Upload
                </Button>
              </Grid>
            </Box>

            <ChatDrawer
              open={openChatDrawer}
              setOpen={setOpenChatDrawer}
              activityId={selectedActivityRow}
            />

            <div className="pmt-controll-table">
              {projectName ? (
                <AgGridPaginatedTable
                  getTableRows={loadProjectActivities}
                  columns={projectActivitiesTable}
                  perPage={10}
                  refreshCounter={activitiesRefreshCount}
                  rowSelection="single"
                  onRowClicked={(params) => {
                    let allowedToSelect =
                      /admin/i.test(user.role) ||
                      projectData.pm_id === user.roleId ||
                      (/user|ReportingManager/i.test(user.role) &&
                        params.data.employee_id === user.roleId);
                    if (allowedToSelect) {
                      setSelectedActivityRow(params.data.id);
                    } else {
                      setSelectedActivityRow(0);
                    }
                  }}
                  onCellClicked={({ rowIndex, column, data }) => {
                    if (column.colId === "0") {
                      let allowedToComment =
                        /admin/i.test(user.role) ||
                        projectData.pm_id === user.roleId ||
                        (/user|ReportingManager/i.test(user.role) &&
                          data.employee_id === user.roleId);
                      if (allowedToComment) {
                        setSelectedActivityRow(data.id);
                        setOpenChatDrawer(true);
                      }
                    }
                  }}
                  // onRowClicked={(params) => {
                  //   let allowedToSelect =
                  //     /admin/i.test(user.role) ||
                  //     projectData.pm_id === user.roleId ||
                  //     (/user|ReportingManager/i.test(user.role) &&
                  //       activities[params.rowIndex].employee_id ===
                  //         user.roleId);
                  //   if (allowedToSelect) {
                  //     setSelectedActivityRow(params.data.id);
                  //   } else {
                  //     setSelectedActivityRow(0);
                  //   }
                  // }}
                  // onCellFocused={({ rowIndex, column }) => {
                  //   if (column.colId === "0") {
                  //     let allowedToComment =
                  //       /admin/i.test(user.role) ||
                  //       projectData.pm_id === user.roleId ||
                  //       (/user|ReportingManager/i.test(user.role) &&
                  //         activities[rowIndex].employee_id === user.roleId);
                  //     if (allowedToComment) {
                  //       setSelectedActivityRow(activities[rowIndex].id);
                  //       setOpenChatDrawer(true);
                  //     }
                  //   }
                  // }}
                />
              ) : (
                <></>
              )}
            </div>
            <ItemDialogUploadDoc
              activityType={"y"}
              open={openDialog.UPLOAD_EXCEL}
              setOpen={toggleDialogOpen}
              onSubmit={onItemDialogAttachmentSubmit}
            />
            <DeleteDialog
              deletingContent={deletingContent}
              setDeletingContent={setDeletingContent}
              onDelete={onDelete}
            />

            <ProjectActivitiesAddActivityDialog
              open={openDialog.ADD_ACTIVITY}
              setTaskCodeBool={setTaskCodeBool}
              setOpen={toggleDialogOpen}
              lowestTasks={lowestTasks}
              employees={employees}
              onAdd={onActivityAdd}
            />

            <ProjectActivitiesUpdateActivityDialog
              open={openDialog.UPDATE_ACTIVITY}
              setOpen={toggleDialogOpen}
              lowestTasks={lowestTasks}
              employees={employees}
              projectData={projectData}
              selectedActivity={activities.find((a) => {
                return a.id === selectedActivityRow;
              })}
              onUpdate={onActivityUpdate}
            />
          </Paper>
        )}
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <ProjectRecurringActivities
          projectSelectId={projectName}
        ></ProjectRecurringActivities>
      </TabPanel>
    </Box>
  );
}
